<template>
  <div class="templateTag" id="templateTag">
    <div style="height: 100%;">
      <!-- <div class="logoTemplate">
        <img width="80px" src="@/assets/0/logo.png">
      </div>-->
      <mbManage
        ref="mbManage"
        :columns="columns"
        @mbSearch="temSearch"
        :tit="indexTit"
        @getAT="mbHuidiao"
        @getAllTask="getAllTask"
      ></mbManage>
      <div v-show="newCreate" v-if="Type==0" class="newCreate" id="newCreate">
        <el-card class="newCreate_card" :body-style="{padding: '0'}">
          <div @click="newClassClick">新增分组</div>
          <div @click="newTemp">新增模板</div>
        </el-card>
      </div>
      <newClass ref="newClass"></newClass>
      <!-- <TaskSearch ref='TaskSearch'></TaskSearch> ,overflow: 'auto'-->
      <div style="background-color: #EEF2F5;" :style="{height: height}" @contextmenu.prevent="blankRC">
        <el-scrollbar style="height:100%;overflow-x:hidden;">
          <folderTree v-if="Type==1" @getAllTask="getAllTask"></folderTree>
          <leftTree
            v-else
            :currentNodeKey="currentNodeKey"
            @getAllTask="getAllTask"
            ref="leftTree"
            :isBlank="isBlank"
            @getAllClass="getAllClass"
            @getTempLeft="getTempLeft"
            @leftSearch="temSearch"
            @newClassClick="newClassClick"
            @newTemp="newTemp"
            :columns="columns"
            :ViewTypeState="ViewTypeState"
            :isViewType="isViewType"
            :filedID="filedIDSub"
            :isBrowseRecords="isBrowseRecords"
          >
          <slot></slot>
          </leftTree>
        </el-scrollbar>
      </div>
      <div class="clearfix bigTitle" v-if="bigTitle">
        <!-- <el-badge is-dot class="item">
          <i class="el-icon-setting" size="mini" @click="templateSet"></i>
        </el-badge> -->
        <!-- <span class="item"> -->
          <i class="item" @click="templateSet"></i>
        <!-- </span> -->
        <span>{{bigTitle}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetAllVisibleTemplateByUserId,
  GetAllTemplateByUserId
} from "@/api/modules/basicData/task";
import Sortable from "sortablejs";
import mbManage from "./mbManage.vue";
import leftTree from "./leftTree.vue";
import folderTree from "./folderTree.vue";
import newClass from "./newClass.vue";
// import TaskSearch from '@/views/task/components/TaskSearch'
import searchJs from "@/util/search";
import { listToTree } from "@/api/modules/basicData/commonData";
export default {
  data() {
    return {
      currentNodeKey:"",
      thisTreeObj: {},
      inputVisible: false,
      inputValue: "",
      dialogVisible: false,
      createTimeFormat(time) {
        //格式化时间
        return time ? time.replace("T", " ").substr(0, 19) : "";
      },
      newCreate: false,
      temporary: [],
      filedIDSub: this.filedID,
      
      // tagItem: {},//当前模板对象
      // allVisibleTem: [],//左侧所有模板
    };
  },
  components: {
    mbManage,
    leftTree,
    newClass,
    folderTree
    // TaskSearch
  },
  computed: {
    category: function() {
      return this.$store.state.task.category;
    },
    userId: function() {
      return this.$store.state.task.userId;
    }
    // allVisibleTem: function() {
    // 	return this.$store.state.task.allVisibleTem
    // },
  },
  watch: {},
  filters: {},
  props: {
    indexTit: String,
    bigTitle: String,
    // tempsType: String,
    columns: Array,
    isBlank: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: "calc(100% - 80px)"
    },
    isViewType: {
      type: Boolean,
      default: false
    },
    ViewTypeState: {
      type: Array,
      default: function() {
        return [];
      }
    },
    filedID: {
      type: String,
      default: "ID"
    },
    Type: {
      type: Number,
      default: 0
    },
    isBrowseRecords: {  //是否显示浏览记录,true:显示,false:不显示
      type: Boolean,
      default: true
    }
  },
  mounted() {
    // this.$store.state.task.columns = this.columns;
    let _this = this;
    document.onclick = function(e) {
      // 空引用时报错
      if (_this.$refs.leftTree) _this.$refs.leftTree.rClickLeft = false;
      _this.newCreate = false;
    };
    this.$store.commit("getAllTemplateLeft");
    this.$root.$on("createdTemp", data => {
      if (data) {
        this.createdGet();
      }
    });
  },
  methods: {
    getCurrentNodeKey(data){//模板选中高亮显示
      this.$refs.leftTree.getCurrentNodeKey(data);
    },
    getLeftAndAll(isLoadMenu) {
      // this.getAlltempLeft();
      this.$store.commit("getAllTemplateLeft",isLoadMenu);
      this.getAllTemp();
    },
    getTempLeft() {
      // this.getAlltempLeft()
      this.$store.commit("getAllTemplateLeft");
    },
    mbHuidiao() {
      this.createdGet();
    },
    getAllClass() {
      this.getAllTemp();
    },
    getAllTemp() {
      this.temporary = [];
      GetAllTemplateByUserId(this.userId, this.category).then(data => {
        // data.forEach((c) => {
        // 	if (c.TEMPTYPE != 2 && !c.PID) {
        // 		console.log('添加PID')
        // 		c.PID = 'zzz'
        // 	}
        // })
        // let temClass = [{
        // 	pid: '',
        // 	NAME: '默认分组',
        // 	ID: 'zzz',
        // 	TEMPTYPE: 2,
        // 	ICON: '我的任务.png',
        // 	ORDERINDEX: 0
        // }]
        console.log("data-->",data);
        
        let temClass = [];
        this.$store.state.task.allTemplate = data;
        data.forEach(c => {
          if (c.TEMPTYPE == 2 || c.TEMPTYPE == 4) {
            temClass.push(c);
          }
        });
        this.$store.state.task.temClass = temClass;
        data.forEach(c => {
          if (c.TEMPTYPE !== 2 && c.TEMPTYPE !== 4) {
            this.temporary.push(c);
          }
        });

        let defaultData = data.filter(item => item.ISDEFAULT == true);
        if (defaultData.length > 0) {
          setTimeout(()=>{
            this.currentNodeKey=defaultData[0].ID.toString();
          },200)
          this.getAllTask(defaultData[0]);
        } else {
          this.$emit("firstLoad");
        }
      });
    },
    getAlltempLeft() {
      // 获取左侧所有模板
      // this.$refs.leftTree.GetAllVisibleTemp()
      this.$store.commit("getAllTemplateLeft");
    },
    getAllTask(data) {
      console.log("点击执行templateTagNew-->data:",data);
      
      // 左侧点击树
      this.templateQuery = data;
      this.$emit("getAllTask", data);
      this.$store.state.task.hhh = true;  //tree的高亮显示
      if (data.TEMPTYPE == 1) {
        this.$store.state.task.resultTagItem = data;
      }
    },
    blankRC(ev) {
      console.log("右击");
      this.newCreate = true;
      let dom = document.getElementById("newCreate");
      dom.style.top = ev.pageY + "px";
      dom.style.left = ev.pageX + "px";
    },
    newClassClick() {
      this.$refs.newClass.dialogVisible = true;
      this.getAllTemp();
    },
    temSearch(data) {
      console.log("openSearch", data);
      this.$emit("openSearch",data);
    },
    newTemp() {
      // this.$refs.TaskSearch.taskSearchDialog = true;
      // this.$root.$emit('search',0);
      // this.$store.commit('createSearchTemp', 0);
      this.$emit("openSearch", 0);
      console.log("新增模板");
      this.getAllTemp();
    },
    allowDrop(draggingNode, dropNode, type) {
      if (!draggingNode.data.PID && !dropNode.data.PID) {
        return type !== "inner";
      }
    },
    allowDrag(draggingNode) {
      // console.log(draggingNode, "draggingNode")
      return draggingNode.data.label.indexOf("二级 3-2") === -1;
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {},
    templateSet() {
      this.getAllTemp();
      this.$refs.mbManage.temporary = this.temporary;
      console.log("点击面板设置之后显示数据:",this.temporary);

      // this.$refs.mbManage.temClass = this.temClass;
      this.$refs.mbManage.dialogVisible = true;
    },
    createdGet() {
      this.getAllTemp();
      console.log(this.temporary);
      this.$refs.mbManage.dormitory = this.temporary;
      this.$refs.mbManage.temporary = this.temporary;
    }
  }
};
</script>

<style scoped>

.templateTag >>> .el-divider--horizontal {
  margin: 5px 0;
}
.templateTag >>> .el-tree-node__content {
  border-bottom: solid 1.3px #e5e5e5;
  height: 40px;
}
.templateTag >>> .el-tree-node__expand-icon {
  right: 20px;
  position: absolute;
}
.templateTag >>> .bigTitle {
  box-sizing: content-box;
  font-family: 'Microsoft Yahei';
  width: 230px;
  font-size: 22px;
  background-color: #23AD9E;
  color: #fff;
  letter-spacing: 0.6px;
  height: 40px;
  line-height: 40px;
  bottom: 0px;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  cursor: pointer;
}
/* .leftTree >>> .el-tree {
} */

.leftTree >>> .custom-tree-node {
  margin-left: 20px;
}
.leftTree >>> .el-tree-node__expand-icon {
  font-size: 18px;
}
/* .templateTag >>> .el-scrollbar__wrap {
  overflow-x: auto;
} */

.custom-tree-node >>> span {
  margin-left: 20px;
}
.logoTemplate {
  height: 100px;
  background-color: #fff;
  text-align: center;
  line-height: 100px;
  border-bottom: 1px solid #e7eaed;
}

.fixTemplate {
  color: #8f98a8;
}

.resultTemplate {
  color: #ffb25f;
}

.seekTemplate {
  color: #23AD9E;
}

.tagOver:hover {
  background-color: red;
}

.amendTag {
  z-index: 9999;
  position: absolute;
  top: 0;
  left: 0;
}

.amendTag .el-card__body {
  padding: 0;
}

.nowSearch,
#tagDiv {
  display: inline-block;
}

#tagDiv {
  padding-left: 10px;
  position: relative;
  top: -2px;
  box-sizing: border-box;
}

.nowSearch {
  position: relative;
  top: -2px;
}

.amendTemplate {
  /* width: 115px; */
  background-color: #fff;

  cursor: pointer;
}

.amendTemplate li {
  size: 12px;
  padding: 5px 10px;
}

.amendTemplate li:hover {
  background-color: #ebf9ff;
  color: #23AD9E;
}

.templateTag {
  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
  position: relative;
}

.newCreate {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}

.newCreate_card {
  width: 75px;
}

.newCreate_card div {
  padding: 5px;
  cursor: pointer;
}

.newCreate_card div:hover {
  background-color: #ebf9ff;
  color: #23AD9E;
}

.item {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url('../../../assets/baseData/set.png') no-repeat;
  /* background-image:url('../../../assets/baseData/set.png') no-repeat; */
  vertical-align: middle;
}
/* .el-tag+.el-tag {
		margin-left: 10px;
	}

	.button-new-tag {
		margin-left: 10px;
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		width: 90px;
		margin-left: 10px;
		vertical-align: bottom;
	} */
</style>
